import React, { useState } from 'react';
import BusinessUnitForm from './views/BusinessUnitForm';
import PageLayout from 'components/layout/PageLayout';
import { useTranslation } from 'react-i18next';
import { useCreateBusinessUnitMutation } from './api/businessUnitApiSlice';

const NewBusinessUnit = () => {

    const [t] = useTranslation("global")

    const [isLocalized, setIsLocalized] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        code: '',
        latitude: null,
        longitude: null
    });

    // API
    const [createBusinessUnit, {
        data: createResult,
        isLoading: createIsLoading,
        isSuccess: createSuccess,
        reset: createReset
    }] = useCreateBusinessUnitMutation()

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value
        }));
    };

    const handleLocationChange = (location) => {
        setFormData((prevData) => ({
            ...prevData,
            latitude: location.lat,
            longitude: location.lng,
        }));
        console.log("Picked Location:" + JSON.stringify(location))
    };

    const handleCheckboxChange = () => {
        setIsLocalized(!isLocalized);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const businessUnit = {
            name: formData.name,
            code: formData.code,
            gps: isLocalized ? {
                latitude: parseFloat(formData.latitude),
                longitude: parseFloat(formData.longitude)
            } : null
        };
        console.log('New Business Unit:', businessUnit);
        // Here you can make an API call to submit the business unit data
        createBusinessUnit(businessUnit)
    };

    const resetForm = () => {
        setFormData({
            name: '',
            code: '',
            latitude: '',
            longitude: ''
        });
        createReset();
    };

    let content = <BusinessUnitForm
        formData={formData}
        submitted={createSuccess}
        handleChange={handleChange}
        handleLocationChange={handleLocationChange}
        handleSubmit={handleSubmit}
        //resetForm={resetForm}
        isLocalized={isLocalized}
        handleCheckboxChange={handleCheckboxChange}
    >
        <div className="alert alert-success">
            Business Unit updated successfully!<br />
            <button className="btn btn-primary ml-3" onClick={resetForm}>Create another one</button>
        </div>
    </BusinessUnitForm>


    return <PageLayout
        pageTitle={t("entity.businessUnits")}
        bodyContent={content}
        isLoadingContent={createIsLoading}
    />
};

export default NewBusinessUnit;